
import { CommonDialog } from "../../../../Common/CommonComponents";
import OrderProductList from "./OrderProductList.vue";
import ProfileSvc from "../../../../../services/profile-svc";
let profileSvc = null;
import OrderDetailed from "@fixit/fixit-no-header/src/models/OrderDetailed";
import Salon from "@fixit/fixit-no-header/src/models/Salon";
export default {
  components: { OrderProductList, CommonDialog },
  props: {
    layout: {
      required: false,
      default: null,
      type: String,
    },
    user: {
      required: true,
    },
  },
  data: () => ({
    orderDetailed: null,
    salon: null,
    loading: false,
    showDialog: false,
    showCancelOrderDialog: false,
  }),
  computed: {
    bookingApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL
        : process.env.VUE_APP_FIXIT_NO_BOOKING_URL;
    },
    orderApi() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_ORDER_API_URL
        : this.$config.VUE_APP_FIXIT_ORDER_API_URL
        ? this.$config.VUE_APP_FIXIT_ORDER_API_URL
        : process.env.VUE_APP_FIXIT_ORDER_API_URL;
    },
    orderId() {
      return this.layout == "portal"
        ? this.$route.params.orderId
        : this.$route.query.orderId;
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    allproductsDeleted() {
      for (let product of this.orderDetailed.products) {
        if (!product.isDeleted) {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    async openReceipt() {
      var pdf = await profileSvc.GetReceiptById(this.orderApi, this.orderId);
      const url = window.URL.createObjectURL(new Blob([pdf]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "kvittering.pdf");
      document.body.appendChild(link);
      link.click();
    },
    redirectOrder() {
      if (this.layout == "chain") {
        this.$router.push({
          query: {
            title: "ProduktOrdredetaljer",
            orderId: this.orderDetailed.parentOrderId,
          },
          params: { order: this.orderDetailed },
        });
      } else {
        this.$router.push({
          name: "ProduktOrdredetaljer",
          params: {
            orderId: this.orderDetailed.parentOrderId,
            order: this.orderDetailed,
          },
        });
      }
    },
    openTracking() {
      window.open(`https://sporing.posten.no/sporing/${this.orderDetailed.trackingNumber}`, '_blank')
    },
    showReceiptBtn(status) {
      if (
        [
          "Sent",
          "Delivered",
        ].includes(status)
      ) {
        return true;
      }
      return false;
    },

    statusText(status) {
      switch (true) {
        case status == "New":
          return "Ordre mottatt";
        case ["Picked", "FinishedPicking", "ReadyForShipment"].includes(status):
          return "Behandles";
        case status == "Sent":
          return "Sendt";
        case status == "Delivered" || status == "NewReturn":
          return "Levert";
        case ["ReturnChecked", "Credited"].includes(status):
          return "Returnert";
        case status == "Cancelled":
          return "Avbestilt";
        default:
          return "";
      }
    },
    // titleText(status) {
    //   switch (true) {
    //     case status == "New":
    //       return "Produktordre mottatt";
    //     case [
    //       "Picked",
    //       "FinishedPicking",
    //       "ReadyForShipment",
    //       "Delivered",
    //       "NewReturn",
    //     ].includes(status):
    //       return "Produktordre behandles";
    //     case ["Sent"].includes(status) &&
    //       this.orderDetailed.trackingNumber != null:
    //       return (
    //         "Produktordre sendt med sporingsnummer " +
    //         this.orderDetailed.trackingNumber +
    //         ":"
    //       );
    //     case ["Sent"].includes(status) &&
    //       this.orderDetailed.trackingNumber == null:
    //       return "Produktordre er sendt";
    //     case ["ReturnChecked", "Credited"].includes(status):
    //       return "Produktordre returnert til:";
    //     case status == "Delivered":
    //       return "Produktordre levert";
    //     case status == "Cancelled":
    //       return "Produktordre avbestilt hos:";
    //     default:
    //       return "";
    //   }
    // },
    statusColor(status) {
      switch (true) {
        case [
          "New",
          "Picked",
          "FinishedPicking",
          "ReadyForShipment",
        ].includes(status):
          return "#472449";
        case ["Delivered", "NewReturn", "ReturnChecked", "Credited", "Sent"].includes(
          status
        ):
          return "#579FA7";
        case status == "Cancelled":
          return "#EA412A";
      }
    },
    paymentMethodText(status) {
      switch (true) {
        case status == "CARD":
          return "Kort";
        case status == "VIPPS":
          return "Vipps";
        case status == "INVOICE":
          return "Faktura";
        case status == "INSTALLMENT":
          return "Delbetaling";
        case status == "VIPPS_DIRECT":
          return "Vipps";
        case status == "KLARNA":
          return "Klarna";
        case status == "APPLE_PAY":
          return "Applepay";
        case status == "GOOGLE_PAY":
          return "Google pay";
        default:
          return "";
      }
    },
    shippingMethodText(methodId) {
      switch (true) {
        case methodId == "2":
          return "Hent på stedet";
        case methodId == "3":
          return "Hent ved behandling";
        case methodId == "5600":
          return "Hjemlevering";
        case methodId == "3584":
          return "Pakke i henteboks";
        case methodId == "5800":
          return "Pakke til hentested";
        default:
          return "";
      }
    },
    async cancelOrder() {
      this.loading = true;
      await profileSvc.CancelOrder(this.orderApi, this.orderId);
      await this.fetchOrder(this.orderId);
      this.loading = false;
      this.showCancelOrderDialog = false;
    },
    async fetchOrder(orderId) {
      this.orderDetailed = await profileSvc.GetOrderDetails(
        this.bookingApi,
        orderId
      );
      this.orderDetailed.orderStatusId = this.allproductsDeleted
        ? "Cancelled"
        : this.orderDetailed.orderStatusId;
    },
  },
  watch: {
    $route(to) {
      if (to.query.orderId != this.orderId) {
        this.fetchOrder(
          this.layout === "portal" ? to.params.orderId : to.query.orderId
        );
      }
    },
  },
  async created() {
    this.loading = true;

    profileSvc = await ProfileSvc(this.$axios);
    await this.fetchOrder(this.orderId);
    let salonResponse = await profileSvc.GetMySalons(
      this.bookingApi,
      this.orderDetailed.siteId,
      "0",
      false
    );
    this.salon = new Salon(salonResponse[0].chainSites[0]);

    this.loading = false;
  },
  beforeDestroy() {
    profileSvc = null;
  },
};
